import LegalPageLayout from "@/components/LegalPageLayout";

export default function About() {
  return (
    <LegalPageLayout
      title="About Us"
      description="About College Unlock — an independent AI-powered college admission guidance platform owned and operated by Spiritual Mantra."
      testid="about-page"
    >
      <p>
        College Unlock is an independent, AI-powered college admission guidance platform that helps
        students across India discover verified colleges, compare their options, and get free
        admission guidance. Our goal is to help every student make the right admission decision with
        confidence.
      </p>
      <p>
        From searching colleges by state, city and course to talking to our AI counsellor and
        requesting expert guidance, College Unlock brings verified data and personalised support
        together in one place.
      </p>

      <h2 data-testid="about-legal-ownership">Legal Ownership</h2>
      <p>
        College Unlock is an independent AI-powered admission guidance platform owned and operated by
        Spiritual Mantra. Spiritual Mantra is responsible for platform operations, technology
        infrastructure, customer support, legal compliance, and payment processing while College
        Unlock continues as the independent public-facing student brand.
      </p>
    </LegalPageLayout>
  );
}
